import Tooltip, { Tooltip as NotPureTooltip } from './Tooltip';
import * as Types from './Tooltip.d';
import { TooltipContent, TooltipChildren, TooltipWrapper } from './Tooltip.styled';

export { NotPureTooltip as Tooltip, TooltipContent, TooltipChildren, TooltipWrapper };
export type TooltipProps = Types.TooltipProps;
export default Tooltip;
